module.exports = __webpack_public_path__ + "img/LongAdmin.4e9c6e86.png";